module.exports = __webpack_public_path__ + "images/mclaren_smallbd9d4c62f7914b9da7b39403c0e1fe17.png";